<template lang='pug'>
div.padding(:class="color")
    slot
</template>

<script>
export default {
    name: "Section",
    props: {
        color: {
            type: String,
            validator: (value) =>
                ["color1", "color2", "color3", "grey"].indexOf(value) !== -1,
        },
    },
};
</script>

<style lang='sass' scoped>
.padding
    padding: 35px 6.5%

.color1
    background-color: $color1
    color: white
    :deep(.VueCarousel-navigation-button)
       color: white

.color2
    background-color: $color2
    color: white
    :deep(.VueCarousel-navigation-button)
       color: white

.color3
    background-color: $color3
    color: white
    :deep(.VueCarousel-navigation-button)
       color: white

.grey
    background-color: whitesmoke

</style>
